import { useEffect } from 'react';

/**
 * Set the document title for as long as this component is mounted.
 *
 * MainApp is what normally sets the title, and it never mounts on the
 * onboarding routes -- so without this the tab reads as whichever station's
 * player the app happened to boot as, on a page that belongs to no station.
 * Restoring the previous title on unmount keeps that behavior intact for
 * everything else in the app.
 */
export default function useTitle(title) {
  useEffect(() => {
    const previous = document.title;
    document.title = title;
    return () => {
      document.title = previous;
    };
  }, [title]);
}
